






import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { LineConfig } from 'konva/types/shapes/Line'
import { Layer } from 'konva/types/Layer'

@Component
export default class BasePaletteLines extends Vue {
  $store!: ExStore

  get lines() {
    return this.$store.state.drawing.lines
  }

  get layer() {
    return (this.$refs.layer as any).getNode() as Layer
  }

  @Watch('lines')
  lineChange() {
    this.layer.batchDraw()
  }
}
